import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Icon } from "@vds/icons";
import TagsInput from "../../../global/components/Tags/TagsInput";
import AdvancedOptions from "./AdvancedOptions";
import { useStatisticContext } from "../contexts/StatisticContext";
import { getLocationHierarchy } from "../../../global/utility/widgetUtils";

const FilterHeader = () => {
  const [viewingExpanded, setViewingExpanded] = useState(false);

  const {
    encryptPayload,
    setEncryptPayload,
    filterlist,
    setFilterList,
    selectedAreas,
    setSelectedAreas,
    selectedFloors,
    setSelectedFloors,
    selectedSubAreas,
    setSelectedSubAreas,
    selectedEventAppObject,
    setSelectedEventAppObject,
    setShowHideFilter,
    setViewingCrossSelected,
    showHideFilter,
    sites,
  } = useStatisticContext();

  const sitesTagList = useSelector((state) => state.sitesReducer.siteTagList);

  // filterlist only holds names; resolve the matching selected location to get its id for the hierarchy lookup.
  const getTagTitle = (tag, name, index) => {
    const selectedByTag = { Floor: selectedFloors, Area: selectedAreas, Subarea: selectedSubAreas }[tag];
    const location = selectedByTag?.[index]?.name === name ? selectedByTag[index] : selectedByTag?.find((l) => l?.name === name);
    if (!location?.id) return undefined;
    const hierarchy = getLocationHierarchy(sitesTagList, location.id);
    return hierarchy ? hierarchy.replaceAll("/", " / ") : undefined;
  };

  const handleCloseIconClickFromTopBar = (e) => {
    if (e.currentTarget.id?.split(":", 2)[0] === "Object") {
      const itemname = e.currentTarget.id.split(":", 2)[1];
      if (itemname === selectedEventAppObject) {
        setSelectedEventAppObject("");
        setEncryptPayload({
          ...encryptPayload,
          objectClass: "",
        });
        setFilterList((prev) => {
          const { Object, ...rest } = prev;
          return rest;
        });
      }
      return;
    } else {
      //delete the tag from SiteList
      setFilterList((prevObject) => {
        const { [e.currentTarget?.id]: removedProperty, ...newObject } =
          prevObject;
        return newObject;
      });

      if (e.currentTarget.id?.split(":", 2)[0] === "Floor") {
        const itemname = e.currentTarget.id.split(":", 2)[1];
        setSelectedFloors(
          selectedFloors.filter((item) => item.name !== itemname)
        );
      }
      if (e.currentTarget.id?.split(":", 2)[0] === "Area") {
        const itemname = e.currentTarget.id.split(":", 2)[1];
        setSelectedAreas(
          selectedAreas.filter((item) => item.name !== itemname)
        );
      }
      if (e.currentTarget.id?.split(":", 2)[0] === "Subarea") {
        const itemname = e.currentTarget.id.split(":", 2)[1];
        setSelectedSubAreas(
          selectedSubAreas.filter((item) => item.name !== itemname)
        );
      }
      setViewingCrossSelected(true);
    }
  };

  return (
    <div className="filterBarSection">
      <AdvancedOptions />

      <div className={`filterBarMain ${viewingExpanded ? 'viewing-expanded' : ''}`}>
        <div className="filterBarMainTopplecontainer">
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div
              style={{ display: "flex", marginRight: "10px", alignItems: "center", justifyContent: "space-between" }}
              onClick={() => setViewingExpanded(!viewingExpanded)}
            >
              <b>Viewing:</b>
              {viewingExpanded && (
                <Icon
                  name="close"
                  style={{ marginLeft: "10px", cursor: "pointer" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setViewingExpanded(false);
                  }}
                />
              )}
            </div>
            <div style={{ display: "flex", marginRight: "10px" }}>
              <TagsInput
                TagList={filterlist}
                SiteList={sites}
                getTagTitle={getTagTitle}
                handleCloseIconClickFromTag={handleCloseIconClickFromTopBar}
              ></TagsInput>
            </div>
          </div>
        </div>
        {!showHideFilter && (
          <div className="graphTowerTopBar">
            {!showHideFilter && (
              <div
                className="graphTowerItems"
                onClick={() => {
                  setShowHideFilter(true);
                }}
              >
                <span className="graphTowerItemsIconSpan" >
                  {" "}
                  <Icon name="filter" />
                </span>
                <span className="graphTowerItemsTitleSpan" >
                  <b>Filter</b>
                </span>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default FilterHeader;
